export class MapTilerDefaultLayer {
    constructor() {
        /* A private variable that is used to store the key for the map tiles. */
        this.keyLayer = 'WgUrAN6BBGKZAAtFhFPe';
        /* An array of default tileLayers of maptiler. */
        this.defaultBaseLayers = [
            {
                name: 'Basic',
                endPoint: `https://api.maptiler.com/maps/basic/{z}/{x}/{y}.png?key=${this.keyLayer}`,
                attribution: '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
                thumbnail: 'base-map-basic',
            },
            {
                name: 'DarkMatter',
                endPoint: `https://api.maptiler.com/maps/darkmatter/{z}/{x}/{y}.png?key=${this.keyLayer}`,
                attribution: '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
                thumbnail: 'base-map-darkmatter',
            },
            {
                name: 'BrightDefault',
                endPoint: `https://api.maptiler.com/maps/bright/{z}/{x}/{y}.png?key=${this.keyLayer}`,
                attribution: '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
                thumbnail: 'base-map-bright',
            },
            {
                name: 'Outdoor',
                endPoint: `https://api.maptiler.com/maps/outdoor/{z}/{x}/{y}.png?key=${this.keyLayer}`,
                attribution: '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
                thumbnail: 'base-map-outdoor',
            },
            {
                name: 'Pastel',
                endPoint: `https://api.maptiler.com/maps/pastel/{z}/{x}/{y}.png?key=${this.keyLayer}`,
                attribution: '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
                thumbnail: 'base-map-pastel',
            },
            {
                name: 'Streets',
                endPoint: `https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=${this.keyLayer}`,
                attribution: '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
                thumbnail: 'base-map-streets',
            },
            {
                name: 'Topo',
                endPoint: `https://api.maptiler.com/maps/c/{z}/{x}/{y}.png?key=${this.keyLayer}`,
                attribution: '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
                thumbnail: 'base-map-streets',
            },
            {
                name: 'Topographique',
                endPoint: `https://api.maptiler.com/maps/topographique/{z}/{x}/{y}.png?key=${this.keyLayer}`,
                attribution: '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
                thumbnail: 'base-map-topographique',
            },
            {
                name: 'Voyager',
                endPoint: `https://api.maptiler.com/maps/voyager/{z}/{x}/{y}.png?key=${this.keyLayer}`,
                attribution: '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
                thumbnail: 'base-map-voyager',
            },
            {
                name: 'Satelite',
                endPoint: `https://api.maptiler.com/maps/hybrid/{z}/{x}/{y}.jpg?key=${this.keyLayer}`,
                attribution: '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
                thumbnail: 'base-map-hybrid',
            },
            {
                name: 'Bright',
                endPoint: `https://api.maptiler.com/maps/514d6aff-859d-4fc9-8f4f-14ee34df1e02/{z}/{x}/{y}.png?key=${this.keyLayer}`,
                attribution: '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
            },
        ];
    }
    /**
     * This function takes in a layer name
     * finds the layer in the default base layers array.
     * @param {string} layerName - string - The name of the layer you want to use.
     * @returns A TileLayer object.
     */
    getBaseLayer(layerName) {
        const baseLayer = this.defaultBaseLayers.find((layer) => layer.name === layerName);
        if (typeof baseLayer === 'undefined') {
            throw new Error(`BaseLayer ${layerName} not exist`);
        }
        return baseLayer;
    }
    /**
     * This function find the thumbnail layer
     * @param {string} layerName - string - The name of the layer you want to use.
     * @returns A thumbnail.
     */
    getThumbnail(layerName) {
        const baseLayer = this.defaultBaseLayers.find((layer) => layer.name === layerName);
        if (typeof baseLayer === 'undefined') {
            throw new Error(`BaseLayer ${layerName} not exist`);
        }
        return baseLayer === null || baseLayer === void 0 ? void 0 : baseLayer.thumbnail;
    }
}
//# sourceMappingURL=mapTilerDefaultLayer.js.map